export const DEFAULT_COLUMNS = ['name' /*, 'size', 'created'*/];
export const MAX_COLUMN_WIDTH = 400;
